import { TYPE_RANGE, TYPE_NUMBER } from "@/constants/numberValueTypes";

const productionStandardFields = {
    value2: "norm",
    value1: "proceeds_min",
};

export function ProductionStandard(data) {
    const { proceeds_min, norm } = data;
    console.log(proceeds_min, norm, "24214")
    return {
        type: proceeds_min!==undefined && proceeds_min!=="" ? TYPE_RANGE : TYPE_NUMBER,
        number: isNaN(norm) ? "" : norm,
        from: isNaN(proceeds_min) ? "" : proceeds_min,
        to: isNaN(norm) ? "" : norm,
    };
}

export function formatProductionStandard(data) {
    if (!data) return {};

    const { type, from, to, number } = data;
    const { value1, value2 } = productionStandardFields;

    const params = {};

    if (type === TYPE_RANGE) {
        params[value1] = Number(from);
        params[value2] = Number(to);
    } else {
        params[value1] = "";
        params[value2] = Number(number);
    }

    return params;
}
